/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { call, put } from 'redux-saga/effects';
import { ApiErrorsCodes } from 'src/constants/endpoints.constant';

interface ApiParams {
  endpoint: string;
  method: string;
  body?: any;
  headers?: any;
  isNotBodyJson?: boolean,
  useParseResponse?: boolean,
};

function* requestApi(params:ApiParams):any {
  const {endpoint, method, body, headers, isNotBodyJson = false, useParseResponse = true } = params;
  let options: ApiParams = {
    endpoint,
    method,
    headers: headers ?? {
      'Content-Type': 'application/json',
    }
  };
  if (body) {
    options['body'] = isNotBodyJson ? body : JSON.stringify({...body});
  }
  try {
    const res = yield call(makeRequest, options);
    if (res?.status === ApiErrorsCodes.UNAUTHORIZED) {
      //TODO:
    }
    if (res?.status === ApiErrorsCodes.SERVICES_NOT_AVAILABLE) {
      //TODO:
    }
    if (useParseResponse) {
      const apiResponse = yield call(parseResponse, res);
      return apiResponse;
    } else {
      return res;
    }
  } catch(err:any) {
    return null;
  }
}

const makeRequest = async (params: ApiParams) => {
  const { endpoint, method, headers, body } = params;
  return fetch(endpoint, {
    method,
    headers,
    body,
  });
};

export const parseResponse = async(response: Response) => {
  let parsedResponse;
  try {
    parsedResponse = await response.clone().json();
  } catch {
    if (response) {
      parsedResponse = await response.text();
    }
  }
  return parsedResponse;
};

export { requestApi, makeRequest };
